export default {
  name: "Takeout",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28.9 9.46 26 3.56c-.17-.34-.52-.56-.9-.56H8.5c-1.09 0-2.13.62-2.57 1.51L3.47 8.85C3.17 9.29 3 9.87 3 10.4V26c0 1.65 1.35 3 3 3h20c1.65 0 3-1.35 3-3V9.9c0-.15-.04-.3-.1-.44zm-3.93-3.45 1.42 2.89h-3.33l1.91-2.89zM5 26V10.4c0-.12.05-.32.17-.51l2.52-4.45c.13-.24.48-.44.81-.44h14.74l-2.87 4.35c-.11.16-.17.35-.17.55V27H6c-.55 0-1-.45-1-1zm21 1h-3.8V10.9H27V26c0 .55-.45 1-1 1zM19 8c0 .55-.45 1-1 1h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1z",
  },
}
